import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import './scss/style.scss';
import './assets/index.css';

import { icons } from './assets/icons';
import { Provider } from 'react-redux';
import store from './store';

React.icons = icons;

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const Layout = React.lazy(() => import('./components/application/layout'));

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <React.Suspense fallback={loading}>
        <Layout />
      </React.Suspense>
    </HashRouter>
  </Provider>,
  document.getElementById('root')
);
